import { Component, Input } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { ViewManager, PdfDateTimeValue } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'bhub-pdf-datetime-cell',
  standalone: false,
  templateUrl: './pdf-datetime-cell.component.html',
  styleUrls: ['./pdf-datetime-cell.component.scss'],
  providers: [DatePipe]
})
export class PdfDatetimeCellComponent extends BaseCellComponent {
  @Input() viewManager: ViewManager | null = null;

  label: string = '';
  showLabel: boolean = true;
  fontSize: number = 12;
  displayValue: string = '';

  private relativeDateOptions: { value: string; days?: number; months?: number; years?: number }[] = [
    { value: 'today', days: 0 },
    { value: 'yesterday', days: -1 },
    { value: 'tomorrow', days: 1 },
    { value: 'last7days', days: -7 },
    { value: 'last30days', days: -30 },
    { value: 'last90days', days: -90 },
    { value: 'lastyear', years: -1 },
    { value: 'next7days', days: 7 },
    { value: 'next30days', days: 30 },
    { value: 'next90days', days: 90 },
    { value: 'nextyear', years: 1 }
  ];

  constructor(private datePipe: DatePipe) {
    super();
  }

  protected initializeCell(): void {
    this.updateDisplayProperties();
  }

  protected onCellOrDataChange(): void {
    this.updateDisplayProperties();
  }

  protected onCellUpdate(): void {
    this.updateDisplayProperties();
  }

  protected onDataSet(data: any): void {
    this.updateDisplayProperties();
  }

  reloadData(): void {
    this.updateDisplayProperties();
  }

  private updateDisplayProperties(): void {
    if (!this.cell) return;

    this.label = this.getConfigValue('pdfDateTimeLabel', '');
    this.showLabel = this.getConfigValue('pdfDateTimeShowLabel', true);
    this.fontSize = this.getConfigValue('pdfDateTimeFontSize', 12);

    const dateTimeValue: PdfDateTimeValue | undefined = this.getConfigValue('pdfDateTimeValue', undefined);
    const format = this.getConfigValue('pdfDateTimeFormat', 'MMMM d, yyyy');

    if (dateTimeValue) {
      const calculatedDate = this.calculateDate(dateTimeValue);
      if (calculatedDate) {
        this.displayValue = this.datePipe.transform(calculatedDate, format) || calculatedDate.toLocaleDateString();
      } else {
        this.displayValue = '[Invalid date]';
      }
    } else {
      this.displayValue = '[Configure date]';
    }
  }

  private calculateDate(dateValue: PdfDateTimeValue): Date | null {
    if (dateValue.mode === 'specific') {
      if (dateValue.value) {
        const date = dateValue.value instanceof Date ? dateValue.value : new Date(dateValue.value);
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
      return null;
    }

    // Relative mode
    const today = new Date();

    if (dateValue.value === 'custom') {
      const result = new Date(today);
      if (dateValue.customDays) {
        result.setDate(result.getDate() + dateValue.customDays);
      }
      if (dateValue.customMonths) {
        result.setMonth(result.getMonth() + dateValue.customMonths);
      }
      if (dateValue.customYears) {
        result.setFullYear(result.getFullYear() + dateValue.customYears);
      }
      return result;
    }

    // Predefined relative option
    const option = this.relativeDateOptions.find(opt => opt.value === dateValue.value);
    if (option) {
      const result = new Date(today);
      if (option.days) {
        result.setDate(result.getDate() + option.days);
      }
      if (option.months) {
        result.setMonth(result.getMonth() + option.months);
      }
      if (option.years) {
        result.setFullYear(result.getFullYear() + option.years);
      }
      return result;
    }

    return null;
  }
}
